import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} home`,
    languageButtonLabel: `Language`,
    languageModalTitle: `Choose a language`,
    languageModalCloseLabel: `Close language menu`,
  },
  languageOptions: {
    'en-US': {
      label: `English (United States)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `English (Kenya)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `English (Nigeria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `English (Singapore)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Portuguese (Portugal)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Portuguese (Brazil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `German`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `German (Austria)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `German (Switzerland)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Spanish`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `French`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Italian`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Dutch`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polish`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Swedish`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Danish`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Finnish`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norwegian (Norway)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Icelandic`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Japanese`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Korean`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Mandarin Chinese`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Cantonese Chinese`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Vietnamese`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Thai`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Indonesian`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Swahili (Kenya)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hindi`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `Bengali`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `Marathi`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `Telugu`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Farsi`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `Urdu`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `Punjabi (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Nigerian Pidgin`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Russian`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Arabic (Saudi Arabia)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `Arabic (United Arab Emirates)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `Arabic (Qatar)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Moroccan Arabic`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Türkçe`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Choose a language`,
    closeLabel: `Close language menu`,
  },
  languageHint: (ctx) => `Locale hopping across ${ctx.localesCount}+ locales.`,
  readPagePrompt: ({languageLabel}) => `Read this page in ${languageLabel}.`,
};
